export default {
  "content": "<g clip-path=\"url(#icon_flashlight_on_svg__a)\"><path d=\"M8 .8c3.97 0 7.2 3.23 7.2 7.2s-3.23 7.2-7.2 7.2S.8 11.97.8 8 4.03.8 8 .8zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z\"/><path d=\"M7.32 13.36l-.24-.04a.703.703 0 01-.47-.71l.24-3.75H4.74c-.26 0-.5-.15-.63-.38-.12-.23-.1-.51.05-.73l3.36-4.8c.18-.25.5-.36.79-.27.3.09.5.36.5.67v3.17h2.46a.7.7 0 01.63.39c.12.24.1.52-.06.74l-3.95 5.42c-.14.19-.35.29-.57.29zm-2.4-5.31h2.36a.41.41 0 01.4.43l-.02.41-.22 3.45 3.65-5.01H8.41c-.22 0-.4-.18-.4-.4V3.66L4.93 8.07l-.01-.02z\"/></g><defs><clipPath id=\"icon_flashlight_on_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};